import { action, computed, makeAutoObservable, observable } from 'mobx';
import { deepCopy } from '../utils/Object.js';
import { publicUrl } from '../utils/url.js';
import { StoreClass } from './Store';



export class SelectedMaterial {
    @observable id;
    @observable category_id;
    store: StoreClass;

    constructor({ id, category_id, store }) {
        makeAutoObservable(this);
        if (!store) {
            throw Error(`store is undefined`);
        }
        this.store = store;
        this.id = id;
        this.category_id = category_id;
    }
    @computed get material() {
        return this.store.materials.find(m => m.id === this.id && m.category_id === this.category_id);
    }
    @computed get category() {
        return this.material?.category;
    }
    @computed get subcategory_id() {
        return this.material?.subcategory_id;
    }
    @computed get isPremium() {
        return Boolean(this.material?.premium || this.material?.material?.premium)
    }
    @computed get isMetalFootrest() {
        return Boolean(this.material?.isMetalFootrest || this.material?.material?.isMetalFootrest)
    }
    @computed get basePrice() {
        const defaultConfiguration = this.store.config.defaultConfiguration;
        const p = defaultConfiguration.find(p => p.category_id === this.category_id);
        if(p){
            return parseFloat(p.price) || 0;
        }
        return 0;
    }
    @computed get fullPrice() {

        return (parseFloat(this.material.fullPrice) || 0);
    }
    @computed get price() {

        return (parseFloat(this.material.price) || 0) - this.basePrice;
    }
    // @computed get materials() {
    //     return this.material_name.map(({ material_name, colorFieldName, channels = [] }) => {

    //         var obj = {
    //             // ...deepCopy(this.material.category.channels || {}),
    //             // ...deepCopy(this.material.subcategory?.channels|| {}),
    //             ...deepCopy(channels),
    //         };
    //         for (const channelName in obj) {
                
    //             if (obj.hasOwnProperty.call(obj, channelName)) {
    //                 const channel = obj[channelName];
    //                 if (channel.color) {
    //                     obj[channelName]['color'] = this.store.sf.hexToShetchfabRgb(channel.color);
    //                 }
    //                 if (channel?.texture?.path) {
    //                     const url = publicUrl(`/${channel.texture.path}`);
    //                     obj[channelName].texture.path = url;
    //                     obj[channelName].texture.uid = this.store.sf.getLoadedTextureUid(url);
    //                 }

    //             }
    //         }
    //         return {
    //             channels: obj,
    //             material_name
    //             colorFieldName
    //         }
    //     })
    // }
    @computed get channels() {
        
        // var obj = {
        //     ...deepCopy(this.material.category.channels || {}),
        //     ...deepCopy(this.material.subcategory?.channels|| {}),
        //     ...deepCopy(this.material.channels),
        // };
        return this.material.channels.map(({ material_name, colorFieldName, channels = [], thumbnail }) => { 
            const obj = deepCopy(channels);
            for (const channelName in obj) {
                
                if (obj.hasOwnProperty.call(obj, channelName)) {
                    const channel = obj[channelName];
                    if (channel.color) {
                        obj[channelName]['color'] = this.store.sf.hexToShetchfabRgb(channel.color);
                    }
                    if (channel?.texture?.path) {
                        const url = publicUrl(`/${channel.texture.path}`);
                        obj[channelName].texture.path = url;
                        obj[channelName].texture.uid = this.store.sf.getLoadedTextureUid(url);
                    }
    
                }
            }
            return {
                channels: obj,
                colorFieldName,
                color: this.material[colorFieldName],
                thumbnail,
                material_name
            };
        })
    }

    @computed get isSmall() {
        return this.category_id === 38;
    }
    @computed get isLarge() {
        return this.category_id === 50;
    }
    @computed get hasLarge() {
        return store.selectedMaterials.some(p => p.category_id === 50);
    } 
    @computed get hasSmall() {
        return store.selectedMaterials.some(p => p.category_id === 38);
    }

    @action render(){
        const store = this.store;
        const sf = this.store.sf;
        const hasLarge = store.selectedMaterials.some(p => p.category_id === 50);
        const hasSmall = store.selectedMaterials.some(p => p.category_id === 38);
        const large = store.selectedMaterials.find(p => p.category_id === 50)?.material;
        const small = store.selectedMaterials.find(p => p.category_id === 38)?.material;
        const isLarge = this.category_id === 50;
        const isSmall = this.category_id === 38;
        // on small
        if(isSmall){
            if(hasLarge){
                if(store.selectedCategoryId === 38){
                    sf.showNodes(this.material.showNodes);
                }else{
                    sf.hideNodes(this.material.showNodes);
                }
            }else{
                sf.showNodes(this.material.showNodes);
            }
        }
       
        // on large
        if(isLarge){
            if(hasSmall){
                if(store.selectedCategoryId === 50 || store.selectedCategoryId !== 38 ){
                    sf.showNodes(this.material.showNodes);
                }else{
                    sf.hideNodes(this.material.showNodes);
                }
            }else{
                sf.showNodes(this.material.showNodes);
            }
        }

       
    }

    async preloadTextures() {
        this.store.showLoader();
        const response = await this.store.sf.loadTextures(this.texturesUrls);
        this.store.hideLoader();
        return response;
    }
    @computed get texturesUrls() {
        var urls = [];
        this.channels.forEach(({material_name, channels}) => {
            for (const channelName in channels) {
                if (Object.hasOwnProperty.call(channels, channelName)) {
                    const channel = channels[channelName];
                    if (channel?.texture?.path && !urls.includes(channel.texture.path)) {
                        urls.push(channel.texture.path);
                    }
    
                }
            }
        });
        return urls;
    }
}
